export default __webpack_public_path__ + "static/media/opening-2.cdfe701e.jpg";